<script lang="ts" setup>
  const emits = defineEmits<{
    login: []
  }>()
</script>

<template lang="html">
  <v-container theme="light" class="d-flex flex-column fill-height">
    <v-row>
      <v-col align="center" align-self="center" style="position: relative">
        <div>
          <v-img width="600" max-width="100vw" src="/oura-black.png" class="ma-auto mt-n12" />

          <span style="position: absolute; left: 50%; bottom: 30%; transform: translate(-50%, 100%)">
            <div class="d-flex flex-row hub">
              <v-icon icon="mdi-hub" class="mt-n2 mr-4" color="text-blue-grey-darken-1" />

              <span class="text-no-wrap text-display-medium font-weight-bold text-blue-grey-darken-1">H U B</span>
            </div>

            <o-btn-primary text="Login" class="px-8 mt-8" @click="emits('login')" />
          </span>
        </div>
      </v-col>
    </v-row>

    <div class="text-headline-small text-blue-grey-darken-1 font-weight-light mx-auto">
      Your gateway to Oura apps, tools and protos
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
  .hub {
    font-size: 8vw;
  }

  @media screen and (min-width: 600px) {
    .hub {
      font-size: 48px !important;
    }
  }
</style>
